import authAxios from 'src/modules/shared/axios/authAxios';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';

export type ElabelListParams = {
  filter?: any;
  orderBy?: string | null;
  limit?: number | null;
  offset?: number | null;
};

export const eLabelQueryKeys = {
  eLabelView: (id: string) => ['eLabelView', id],
  eLabelList: (params: ElabelListParams) => ['eLabelView', params],
};

export async function update(id, data) {
  const body = {
    id,
    data,
  };

  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.put(
    `/tenant/${tenantId}/e-label/${id}`,
    body,
  );

  return response.data;
}

export async function destroyAll(ids) {
  const params = {
    ids,
  };

  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.delete(`/tenant/${tenantId}/e-label`, {
    params,
  });

  return response.data;
}

export async function create(data) {
  const body = {
    data,
  };

  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.post(`/tenant/${tenantId}/e-label`, body);

  return response.data;
}

export async function importCSV(values, importHash) {
  const body = {
    data: values,
    importHash,
  };

  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.post(
    `/tenant/${tenantId}/e-label/import`,
    body,
  );

  return response.data;
}

export async function find(id) {
  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.get(`/tenant/${tenantId}/e-label/${id}`);

  return response.data;
}

export async function list(params?: ElabelListParams) {
  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.get(`/tenant/${tenantId}/e-label`, {
    params,
  });

  return response.data;
}

export async function listAutocomplete(query, limit, filter) {
  const params = {
    query,
    limit,
    filter,
  };

  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.get(
    `/tenant/${tenantId}/e-label/autocomplete`,
    {
      params,
    },
  );

  return response.data;
}

export async function findAllByEanAndYear(
  productEan: string,
  productYear: string,
) {
  const tenantId = AuthCurrentTenant.get();

  const response = await authAxios.get(
    `/tenant/${tenantId}/e-label/gtin/${productEan}/${productYear}`,
  );

  return response.data;
}
